import { useRef, useCallback } from "react";

export function GlowCard({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const glowRef = useRef<HTMLDivElement>(null);

  const handleMove = useCallback((e: React.MouseEvent) => {
    if (!ref.current || !glowRef.current) return;
    const rect = ref.current.getBoundingClientRect();
    glowRef.current.style.left = `${e.clientX - rect.left - 200}px`;
    glowRef.current.style.top = `${e.clientY - rect.top - 200}px`;
  }, []);

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden ${className}`}
      onMouseMove={handleMove}
      onMouseEnter={() => {
        if (glowRef.current) glowRef.current.style.opacity = "1";
      }}
      onMouseLeave={() => {
        if (glowRef.current) glowRef.current.style.opacity = "0";
      }}
    >
      <div
        ref={glowRef}
        className="absolute pointer-events-none transition-opacity duration-500 z-[3]"
        style={{
          width: 400,
          height: 400,
          background:
            "radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%)",
          opacity: 0,
        }}
      />
      {children}
    </div>
  );
}
